<div class="tw-bg-white tw-rounded-lg tw-shadow-md tw-p-5 tw-w-full tw-shadow-tb tw-mb-6">
  <mh-semantic-indicator
    [positivePercentage]="positiveSemanticPercentage"
    [empty]="showSemanticEmpty"
    [hideActionButton]="true"
    (onActionClick)="onActionClick()">
  </mh-semantic-indicator>
</div>
